/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLastFlattened_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_viewer">;
    readonly " $refType": "ReplyListContainerLastFlattened_viewer";
};
export type ReplyListContainerLastFlattened_viewer$data = ReplyListContainerLastFlattened_viewer;
export type ReplyListContainerLastFlattened_viewer$key = {
    readonly " $data"?: ReplyListContainerLastFlattened_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLastFlattened_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLastFlattened_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListCommentContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '7eace67a21f261024242105354f268ee';
export default node;
